import { render } from "./CHeader.vue?vue&type=template&id=2cec92df"
import script from "./CHeader.vue?vue&type=script&lang=js"
export * from "./CHeader.vue?vue&type=script&lang=js"

import exportComponent from "/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__